import {createAction} from "@reduxjs/toolkit";

export const setProgramCategoryId = createAction('SET_PROGRAM_CATEGORY_ID');